import { render, staticRenderFns } from "./AddSourceWiseTransactionFeeConfiguration.vue?vue&type=template&id=d2ab941c&"
import script from "./AddSourceWiseTransactionFeeConfiguration.vue?vue&type=script&lang=js&"
export * from "./AddSourceWiseTransactionFeeConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports